import { Link } from 'react-router';

import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-24">
      <Text variant="web/display/3xl" className="mb-4">
        404
      </Text>
      <Text variant="web/body/medium/md" className="text-secondary mb-8">
        The page you're looking for doesn't exist.
      </Text>
      <Link to="/">
        <Button variant="secondary">Back to Home</Button>
      </Link>
    </div>
  );
}
